import React from 'react';
import AppGuide from '../pages/AppGuide';
import NotFound from '../pages/NotFound';
import PrivacyPolicy from '../pages/Term/PrivacyPolicy.jsx';
import BetaTestPrivacyPolicy from '../pages/Term/BetaTestPrivacyPolicy.jsx';
import TermOfUse from '../pages/Term/TermOfUse.jsx';
import { APP_INVITE_CODE_PATH, APP_INVITE_PATH, APP_OPEN_PATH } from './paths';

const routeConfig = [
  {
    path: APP_OPEN_PATH,
    element: <AppGuide />
  },
  {
    path: APP_INVITE_PATH,
    element: <AppGuide />
  },
  {
    path: APP_INVITE_CODE_PATH,
    element: <AppGuide />
  },
  {
    path: '/term/privacyPolicy',
    element: <PrivacyPolicy />
  },
  {
    path: '/term/privacyPolicy/betaTest',
    element: <BetaTestPrivacyPolicy />
  },
  {
    path: '/term/termOfUse',
    element: <TermOfUse />
  },
  { path: '*', element: <NotFound /> }
];

export default routeConfig;
